import { Slider, Stack } from '@mui/material';
import './VolumeSlider.scss';
import { useContext } from 'react';
import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { ScreenContext } from '@/contexts/ScreenContext';

export enum VolumeType {
    Game,
    Studio,
}
type VolumeChangeHandler = (volume: number) => void;
type VolumeSliderProps = {
    type: VolumeType;
    volume: number;
    handleVolumeChange: VolumeChangeHandler;
};
export const VolumeSlider = (props: VolumeSliderProps) => {
    const { type, volume, handleVolumeChange } = props;
    const { isMobile } = useContext(ScreenContext);
    const { setTestGameVolumeAudio, playButtonAudio } =
        useContext(AudioPlayContext);
    return (
        <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
            <Slider
                aria-label="Volume"
                value={volume}
                onChange={(_, value) => {
                    handleVolumeChange(value as number);
                }}
                onChangeCommitted={(event, value) => {
                    //incase received event twice (one is mouse event and other one is touch event)
                    if (isMobile && event.type === 'mouseup') {
                        return;
                    }
                    if (type === VolumeType.Game) {
                        setTestGameVolumeAudio(value as number);
                        playButtonAudio();
                    }
                }}
                valueLabelDisplay="auto"
                min={0}
                max={100}
                color="primary"
            />
        </Stack>
    );
};
